var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProTagLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.303,
    height: 21.196,
    viewBox: "0 0 41.303 21.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11971",
    "data-name": "Group 11971",
    transform: "translate(-3210.875 -3063.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43957",
    "data-name": "Path 43957",
    d: "M4327.712,938.036v20.946h40.958L4362.5,948.36l6.166-10.324Z",
    transform: "translate(-1116.712 2125.491)",
    fill: "#1bfed5",
    stroke: "#111",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43958",
    "data-name": "Path 43958",
    d: "M7.074-4.182a2.6,2.6,0,0,1-.8,1.955,3.414,3.414,0,0,1-2.455.778H2V2.487H.77V-6.942H3.814a3.45,3.45,0,0,1,2.428.771A2.589,2.589,0,0,1,7.074-4.182ZM3.814-2.464A2.188,2.188,0,0,0,5.329-2.91a1.638,1.638,0,0,0,.487-1.272q0-1.745-2-1.745H2v3.463Zm9.754,4.951L11.322-1.368H9.834V2.487H8.6V-6.942h3.044a4.041,4.041,0,0,1,1.806.365,2.543,2.543,0,0,1,1.1.988,2.753,2.753,0,0,1,.365,1.42,2.775,2.775,0,0,1-.561,1.718,2.744,2.744,0,0,1-1.684.988l2.367,3.95ZM9.834-2.356h1.813a2.057,2.057,0,0,0,1.5-.494,1.769,1.769,0,0,0,.5-1.319,1.688,1.688,0,0,0-.494-1.3,2.149,2.149,0,0,0-1.508-.46H9.834ZM21.1,2.582a4.758,4.758,0,0,1-2.395-.616A4.506,4.506,0,0,1,17,.248a4.919,4.919,0,0,1-.629-2.482A4.919,4.919,0,0,1,17-4.716a4.506,4.506,0,0,1,1.711-1.718A4.758,4.758,0,0,1,21.1-7.05a4.784,4.784,0,0,1,2.408.616,4.471,4.471,0,0,1,1.7,1.711,4.951,4.951,0,0,1,.622,2.489A4.951,4.951,0,0,1,25.216.255a4.471,4.471,0,0,1-1.7,1.711A4.784,4.784,0,0,1,21.1,2.582Zm0-1.069a3.475,3.475,0,0,0,1.779-.46A3.237,3.237,0,0,0,24.127-.259a4.145,4.145,0,0,0,.453-1.975,4.135,4.135,0,0,0-.453-1.982,3.262,3.262,0,0,0-1.238-1.305,3.465,3.465,0,0,0-1.786-.46,3.465,3.465,0,0,0-1.786.46,3.262,3.262,0,0,0-1.238,1.305,4.135,4.135,0,0,0-.453,1.982,4.145,4.145,0,0,0,.453,1.975,3.237,3.237,0,0,0,1.245,1.312A3.475,3.475,0,0,0,21.1,1.513Z",
    transform: "translate(3215.627 3076.234)",
    fill: "#111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProTagLight);
export default __webpack_public_path__ + "static/media/pro-tag-light.4979d0677bbc9b57c1f895256716d294.svg";
export { ForwardRef as ReactComponent };